var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('br'),_c('b-container',[_c('div',{staticClass:"alert alert-danger text-center"},[_c('p',[_vm._v(" Actualmente ud se encuentra en el registro electoral. ")]),_c('br')])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }